import { TableViewButton, TableViewButtonProps } from '@components/button';
import { Group } from '@components/layout';
import { CreateFolderButton } from './createFolder';
import { ServicesButton } from './services';
import { UploadFileButton } from './uploadFile';

type VolumeExplorerHeaderProps = {
  directory: string[];
  tableView: TableViewButtonProps['mode'];
  volumeId: string;
  permission: string;
  onUploadData: () => void;
  onTableViewChange: TableViewButtonProps['onChange'];
  onFolderCreate: () => void;
};

export const VolumeExplorerHeader = ({
  directory,
  tableView,
  volumeId,
  permission,
  onUploadData,
  onFolderCreate,
  onTableViewChange,
}: VolumeExplorerHeaderProps) => {
  const writePermission = permission === 'write';

  return (
    <Group justifyContent="space-between" alignItems="center">
      <Group gap={4}>
        <UploadFileButton
          disabled={!writePermission}
          volumeId={volumeId}
          directory={directory}
          onUploadComplete={onUploadData}
        />
        <CreateFolderButton
          disabled={!writePermission}
          volumeId={volumeId}
          directory={directory}
          onFolderCreate={onFolderCreate}
        />
        <ServicesButton disabled={!writePermission} volumeId={volumeId} directory={directory} />
      </Group>
      <TableViewButton mode={tableView} onChange={onTableViewChange} />
    </Group>
  );
};
